import { render, staticRenderFns } from "./holle.vue?vue&type=template&id=4b40b88a&scoped=true"
import script from "./holle.vue?vue&type=script&lang=js"
export * from "./holle.vue?vue&type=script&lang=js"
import style0 from "./holle.vue?vue&type=style&index=0&id=4b40b88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40b88a",
  null
  
)

export default component.exports